export default __webpack_public_path__ + "static/media/robotframework.5e25175a.svg";